/* eslint-disable @nx/enforce-module-boundaries */
import { initReactI18next } from 'react-i18next';
import i18n, { LanguageDetectorModule } from 'i18next';
import { extractLocaleFromUrl } from '@ae/i18n';
import { locales } from '@ae/shared';

type Resources = { [x: string]: { [x: string]: string } };

const namespaces = ['common', 'footer', 'header', 'mr', 'profile', 'favorites'];
const resources: Resources = {};

for (const locale of locales) {
  resources[locale] = {};

  for (const ns of namespaces) {
    try {
      resources[locale][ns] = require(
        `../../../libs/i18n/public/locales/${locale}/${ns}.json`
      );
    } catch (error) {
      console.error(
        `Failed to load translation file: /locales/${locale}/${ns}.json`,
        error
      );
    }
  }
}

const languageDetector: LanguageDetectorModule = {
  type: 'languageDetector',
  detect: () => extractLocaleFromUrl(window.location.href),
};

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    resources,
    ns: namespaces,
    defaultNS: 'common',
    detection: {
      order: ['subdomain'],
    },
    supportedLngs: locales,
    react: {
      useSuspense: false,
    },
  });

export default i18n;
